import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsAccordion from 'components/blocks/LandingsAccordion'
import LandingsTitle from 'components/blocks/LandingsTitle'
import {Container, Row, Col} from 'components/elements/grid'
import {IW2Content} from 'pages/make-your-w2'

import s from './W2Faq.module.scss'
const cx = cn.bind(s)

interface IW2FaqProps {
	className?: string
	content: IW2Content['faq']
}

/** W2Faq block component */
const W2Faq: FC<IW2FaqProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />
				<Row>
					<Col>
						<LandingsAccordion items={content?.items} />
					</Col>
				</Row>
			</Container>
		</div>
	)
}

W2Faq.displayName = 'W2Faq'

export default W2Faq
